module.exports = __webpack_public_path__ + "img/frisky-social-share-image.20d822e4.png";